// react
import { useContext } from 'react';

// types
import { Account } from '../../../../../@types';

// context
import { ContextAccountsLocal } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableAccounts } from '../../../../tables/cards/TableAccounts/TableAccounts';

export const Local = () => {
	// context
	const { accountsLocal, isLoadingAccountsLocal, paginationAccountsLocal, refetchAccountsLocal } =
		useContext(ContextAccountsLocal);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TableAccounts
								accounts={accountsLocal as Account[]}
								isLoading={isLoadingAccountsLocal}
								pagination={paginationAccountsLocal}
								refetchAccounts={refetchAccountsLocal}
								type="LOCAL"
							/>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</Grid>
	);
};
